<section class="mini-showcase">
	<app-showcase-element
		class="mini-showcase--element-1"
		[entity]="elements()?.[0]"
	></app-showcase-element>
	<app-showcase-element
		class="mini-showcase--element-2"
		[entity]="elements()?.[1]"
	></app-showcase-element>
	<app-showcase-element
		class="mini-showcase--element-3"
		[entity]="elements()?.[2]"
	></app-showcase-element>
</section>
